export default __webpack_public_path__ + "static/media/ai.b17a51e0.svg";